module.exports = __webpack_public_path__ + "static/cathay-2-be489825dfe25485ba970f59f207a40e.png";